import { render, staticRenderFns } from "./helloworld.vue?vue&type=template&id=449f5dfa&"
import script from "./helloworld.vue?vue&type=script&lang=js&"
export * from "./helloworld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports